import styled from 'styled-components';

import {
  Content as ModalContent,
  Header as ModalHeader,
  Subtitle as ModalSubtitle,
} from '~/components/Modal/styles';
import grid from '~/styles/grid';

export const Container = styled.div`
  ${ModalContent} {
    padding: ${grid.lg};
    max-width: 960px;
    max-height: 500px;
  }

  ${ModalHeader} {
    font-weight: 600;
    color: #4d4d4d;
    margin-bottom: ${grid.xl};

    &::after {
      display: none;
    }
  }

  ${ModalSubtitle} {
    font-size: 14px;
    color: #4d4d4d;
  }
`;

export const TableContainer = styled.div`
  min-height: 255px;
  overflow-y: auto;
  padding-right: 15px;
`;

export const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  height: 80px;
  position: sticky;
  bottom: 0;
  background: white;
  gap: ${grid.sm};
  margin-top: ${grid.xl};

  button {
    height: ${grid.xxl};
  }

  button:nth-child(1) {
    width: 149px;
  }
`;

export const FailureTitleContainer = styled.div`
  margin-bottom: ${grid.xl};
`;

export const FailureTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${grid.sm};

  h2 {
    margin: 0 0 0 ${grid.sm};
  }
`;
